import { defineAsyncComponent, defineComponent } from 'vue';

import { isMswEnabled } from './browser';

let MockedRequestsDisplay: ReturnType<typeof defineComponent>;
const Noop = defineComponent({ name: 'Noop', setup: () => () => null });

// The request bar is a dev aid — keep it out of deployed (test-system) builds.
if (isMswEnabled() && import.meta.env.DEV) {
  MockedRequestsDisplay = defineAsyncComponent(
    () => import('./PrivateMockedRequestsDisplay.vue')
  );
} else {
  MockedRequestsDisplay = Noop;
}

export default MockedRequestsDisplay;
